<template>
  <v-card class="announcement" flat>
    <v-row class="table-header">
      <v-col>公告</v-col>
      <v-col style="max-width: 300px"></v-col>
    </v-row>
    <template v-for="(item, i) in announcements">
      <v-row>
        <template v-if="!item.editing">
          <v-col>{{ item.content }}</v-col>
        </template>
        <template v-else>
          <v-col>
            <v-textarea auto-grow dense outlined hide-details v-model="item.content" :rules="[$rules.notEmpty]"></v-textarea>
          </v-col>
        </template>
    
        <v-col style="max-width: 300px">
          <v-btn icon color="indigo" class="mx-1" @click="moveUp(i)">
            <v-icon>fa-arrow-up</v-icon>
          </v-btn>
          <v-btn icon color="red" class="mx-1" @click="moveDown(i)">
            <v-icon>fa-arrow-down</v-icon>
          </v-btn>
          <v-btn icon color="indigo" class="mx-1" v-if="!item.editing" @click="item.editing = true">
            <v-icon>fa-edit</v-icon>
          </v-btn>
          <v-btn icon color="green" class="mx-1" v-else @click="save(i)">
            <v-icon>fa-save</v-icon>
          </v-btn>
          <DeleteConfirmBtn icon color="red" btnClass="mx-1" @delete="deleteItem(i)">
            <v-icon>fa-trash-alt</v-icon>
          </DeleteConfirmBtn>
        </v-col>
      </v-row>
      <v-divider class="my-6"></v-divider>
    </template>
    <v-btn block class="pink my-3" @click="addRow">
      <v-icon color="white">fa-plus</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import DeleteConfirmBtn from '@/components/DeleteConfirmBtn'
export default {
  components: { DeleteConfirmBtn },
  data() {
    return {
      announcements: [],
    }
  },
  created() {
    this.getAnnouncement()
  },
  methods: {
    getAnnouncement() {
      this.axios.get('/announcement').then(response => {
        const data = response.data || []
        this.announcements = data.map(announcement => {
          return {content: announcement, editing: false}
        })
      })
    },
    deleteItem(i) {
     this.announcements.splice(i, 1)
     this.submit()
    },
    addRow() {
      this.announcements.push({content: '', editing: true})
    },
    moveUp(i) {
      if(i == 0) {
        return
      }
      this.announcements[i] = this.announcements.splice(i - 1, 1, this.announcements[i])[0]
      if(!this.announcements[i].editing && !this.announcements[i - 1].editing) {
        this.submit()
      }
    },
    moveDown(i) {
      if(i == this.announcements.length -1) {
        return
      }
      this.announcements[i] = this.announcements.splice(i + 1, 1, this.announcements[i])[0]
      if(!this.announcements[i].editing && !this.announcements[i + 1].editing) {
        this.submit()
      }
    },
    save(i) {
      if(this.announcements[i].content !== '') {
        this.announcements[i].editing = false
        this.submit().then().catch(() => {
          this.announcements[i].editing = true
        })
      }
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.axios.post('/admin/announcement', {
          data: this.announcements.filter(item => !item.editing).map(item => item.content)
        }).then(response => {
          this.$root.$emit('alert', 'success', '更新成功')
        }).catch(() => {
          this.$root.$emit('alert', 'error', '更新失敗')
        })
      })
    }
  }
}
</script>

<style lang="scss">
.announcement {
  padding: 40px;
}
</style>